/**
 * branding.js — центральный конфиг платформы.
 *
 * Значения задаются через env при сборке фронтенда:
 *   REACT_APP_BASE_DOMAIN    — базовый домен (default: fixty.io)
 *   REACT_APP_BRAND_NAME     — название платформы (default: Fixty)
 *   REACT_APP_LOGO_PATH      — путь к логотипу (default: /fixty-logo-light.svg)
 *   REACT_APP_LOGO_PATH_DARK — тот же логотип для тёмного фона; не задан =
 *                              используется REACT_APP_LOGO_PATH
 *   REACT_APP_BRAND_TAGLINE  — тэглайн на странице логина/регистрации;
 *                              пустая строка = не показывать (для white-label)
 *
 * Для vsenapole.ru в .env на сервере:
 *   REACT_APP_BASE_DOMAIN=vsenapole.ru
 *   REACT_APP_BRAND_NAME=Все на поле
 *   REACT_APP_LOGO_PATH=/vsenapole-logo.svg
 *   REACT_APP_LOGO_PATH_DARK=/vsenapole-logo-dark.svg
 *   REACT_APP_BRAND_TAGLINE=
 *
 * ⚠️ Логотип в разметку вставлять через <BrandLogo/>, а не <img src={LOGO_PATH}/>:
 * компонент сам выбирает светлый/тёмный файл по фону.
 */

export const BASE_DOMAIN    = process.env.REACT_APP_BASE_DOMAIN || 'fixty.io';
export const BRAND_NAME     = process.env.REACT_APP_BRAND_NAME  || 'Fixty';
export const LOGO_PATH      = process.env.REACT_APP_LOGO_PATH   || '/fixty-logo-light.svg';
export const LOGO_PATH_DARK = process.env.REACT_APP_LOGO_PATH_DARK
  || process.env.REACT_APP_LOGO_PATH
  || '/fixty-logo-dark.svg';
// null = использовать i18n-ключ; пустая строка = скрыть тэглайн
export const BRAND_TAGLINE  = process.env.REACT_APP_BRAND_TAGLINE !== undefined
  ? process.env.REACT_APP_BRAND_TAGLINE
  : null;
/** Инстанс «Все на поле» (vsenapole.ru) — не путать с isRuInstance(): тот ловит и РФ-тенантов на fixty.io. */
export const IS_VSENAPOLE  = BASE_DOMAIN === 'vsenapole.ru';
export const BRAND_URL      = `https://${BASE_DOMAIN}`;

/**
 * Юр-документы инстанса. Двойник на бэке — LEGAL_DOCS в backend/config/domains.js
 * (там же редакции, которые пишутся в legal_acceptances).
 *
 * На vsenapole.ru лендинг живёт на Tilda со своими адресами страниц; на
 * fixty.io — /privacy, оферты нет. OFFER_URL = null → галочек акцепта на
 * регистрации нет. REACT_APP_PRIVACY_URL оставлен как ручной оверрайд.
 */
export const PRIVACY_URL = process.env.REACT_APP_PRIVACY_URL
  || (IS_VSENAPOLE ? 'https://vsenapole.ru/polyconf' : `${BRAND_URL}/privacy`);
export const OFFER_URL = IS_VSENAPOLE ? 'https://vsenapole.ru/dogofert' : null;
export const REGISTER_HOST  = `app.${BASE_DOMAIN}`;
export const DEMO_HOST      = `demo.${BASE_DOMAIN}`;

/**
 * Вкладка «Подписка» в Настройках доступна на этом инстансе?
 * На vsenapole.ru ВРЕМЕННО скрыта (решение владельца). Пока false — все пути,
 * ведущие в неё (плашка/баннер биллинга), не показывают кнопку перехода:
 * текст плашки самодостаточен. Открыть вкладку = поменять эту строку (и
 * бэкенд-двойник SUBSCRIPTION_TAB_ENABLED в backend/config/domains.js —
 * от него зависит ссылка в письмах).
 */
export const SUBSCRIPTION_TAB_ENABLED = BASE_DOMAIN !== 'vsenapole.ru';

/**
 * Признак РФ-контура: инстанс vsenapole (BASE_DOMAIN=vsenapole.ru) ИЛИ
 * РФ-тенант на fixty.io (страна организации = Россия, поле org_country
 * пользователя / country организации). Общий хелпер для всего, что должно
 * скрываться или переодеваться под РФ (интеграции недоступных сервисов,
 * брендинг писем и внешних ботов под реального провайдера контура).
 */
export function isRuInstance(country) {
  return BASE_DOMAIN === 'vsenapole.ru' || String(country || '').toUpperCase() === 'RU';
}
